import { view, globals } from '@yola/ws-sdk';
import constants from '../constants';
import { mutatePaletteElement } from './prepare-palette-element';
import compilePaletteIfNeeded from './compile-palette-if-needed';

export default function updateColorPaletteCode(palette) {
  const compiled = compilePaletteIfNeeded(palette);

  globals.operations.changeGlobalContent(constants.GLOBAL_HEADER_CODE, (globalContent) =>
    mutatePaletteElement({
      parentNode: globalContent,
      compiledPalette: compiled,
    })
  );

  const liveDocument = view.accessors.getLiveDocument();
  /**
   * `liveDocument` is unavailable when user haven't finished initial site setup.
   * So there is no sense to update live DOM as it will be initiated later.
   */
  if (liveDocument) {
    mutatePaletteElement({
      parentNode: liveDocument,
      compiledPalette: compiled,
    });
  }
}
